module.exports = __webpack_public_path__ + "img/BTC-logo.e157bcf7.svg";